import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import { ServiceEntryModel } from '../model/index';

@Injectable()
export class ServiceEntryService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private serviceEntryUrl = 'api/serviceEntry';  // URL to web api
    public  testingTrailUrl = 'api/testingTrail';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    //   getServiceWalkInList(query: any): Promise<ServiceEntryModel[]> {
    //     let params: URLSearchParams = new URLSearchParams();
    //     for (let key in query) {
    //         params.set(key.toString(), query[key]);
    //     }
    //
    //     let options = new RequestOptions({
    //         headers: this.headers,
    //         search: params
    //     });
    //
    //     const url = `${this.serviceEntryUrl}/getServiceWalkInList`;
    //     return this.http.get(url, options)
    //         .toPromise()
    //         .then(this.extractData)
    //         .catch(this.handleError);
    // }
    //
    // getWalkInList(query: any): Promise<ServiceEntryModel[]> {
    //     let params: URLSearchParams = new URLSearchParams();
    //     for (let key in query) {
    //         params.set(key.toString(), query[key]);
    //     }
    //
    //     let options = new RequestOptions({
    //         headers: this.headers,
    //         search: params
    //     });
    //
    //     const url = `${this.serviceEntryUrl}/getWalkInList`;
    //     return this.http.get(url, options)
    //         .toPromise()
    //         .then(this.extractData)
    //         .catch(this.handleError);
    // }
    //
    // addUpdateWalkIn(pageData: any): Promise<any> {
    //     const url = `${this.serviceEntryUrl}/addUpdateWalkIn`;
    //     return this.http
    //         .post(url, $.param(pageData), { headers: this.headers })
    //         .toPromise()
    //         .then(res => res.json() as any)
    //         .catch(this.handleError);
    //
    // }
    //
    //  addServiceWalkIn(query: any): Promise<ServiceEntryModel[]> {
    //     let params: URLSearchParams = new URLSearchParams();
    //     for (let key in query) {
    //         params.set(key.toString(), query[key]);
    //     }
    //
    //     let options = new RequestOptions({
    //         headers: this.headers,
    //         search: params
    //     });
    //
    //     const url = `${this.serviceEntryUrl}/addServiceWalkIn`;
    //     return this.http.get(url, options)
    //         .toPromise()
    //         .then(this.extractData)
    //         .catch(this.handleError);
    // }
    // saveServiceDetails(data: any): Promise<ServiceEntryModel> {
    //
    //     const url = `${this.testingTrailUrl}/addServiceEntry`;
    //
    //     return this.http
    //         .post(url, $.param(data), { headers: this.headers })
    //         .toPromise()
    //         .then(res => res.json() as ServiceEntryModel)
    //         .catch(this.handleError);
    // }
    //  getServiceModelDetails(data: any): Promise<ServiceEntryModel> {
    //     const url = `${this.serviceEntryUrl}/getServiceModelDetails`;
    //     return this.http
    //         .post(url, $.param(data), { headers: this.headers })
    //         .toPromise()
    //         .then(res => res.json() as ServiceEntryModel)
    //         .catch(this.handleError);
    // }
    //
    // deleteServiceWalkIn(walkInData: any): Promise<ServiceEntryModel> {
    //     const url = `${this.serviceEntryUrl}/deleteServiceWalkIn`;
    //     return this.http
    //         .post(url, $.param(walkInData), { headers: this.headers })
    //         .toPromise()
    //         .then(res => res.json() as ServiceEntryModel)
    //         .catch(this.handleError);
    // }
    //
    //  deleteGridList(rowData: any): Promise<ServiceEntryModel> {
    //     const url = `${this.serviceEntryUrl}/deleteGridList`;
    //     return this.http
    //         .post(url, $.param(rowData), { headers: this.headers })
    //         .toPromise()
    //         .then(res => res.json() as ServiceEntryModel)
    //         .catch(this.handleError);
    // }

    private handleError(error: any): Promise<ServiceEntryModel> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/serviceEntry.service.ts